const testIdFormatter = (value, prefix = '') => `${prefix}${prefix ? '-' : ''}${value}`.toLowerCase().replace(/\s/g, "");

export default testIdFormatter;